module.exports = __webpack_public_path__ + "media/images/views/dashboard/toll-ef16ac0fe761008bf397d4ebde8712ca.png";